<!--
 * @Description: 子表单
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <!-- 子表 -->
  <div class="sub-form-card-title">
    <div>
      {{ modulesItem?.label || '子表单' }}
      <jw-tooltip v-if="modulesItem?.toast">
        <icon-question-circle size="12" class="card-tooltip" />
        <template #content> {{ modulesItem.toast }} </template>
      </jw-tooltip>
      <qf-icon-required v-if="modulesItem.isRequired == 1 || modulesItem?.conditionsIsRequired == 1" />
    </div>
    <div class="add-btn">
      <!--新建  -->
      <jw-link @click="addDetail" v-if="isCanEdit && (from == 30 || type == 30 || (type == 40 && modulesItem?.permission?.canEdit == 1 && modulesItem?.permission?.detail?.add == 1))" :loading="data.loading">{{ $t('新建') }}</jw-link>
    </div>
  </div>

  <!-- 全选状态 按钮 -->
  <template v-if="data.checkedAllShow">
    <div class="margin-b-10">
      <jw-button
        size="mini"
        style="margin-right: 10px"
        @click="
          () => {
            data.checkedAll = false;
            data.indeterminate = false;
            data.selectIds = [];
            data.checkedAllShow = false;
          }
        "
      >{{ $t('取消操作') }}</jw-button
      >

      <jw-popconfirm type="error" v-if="data.selectIds?.length > 0" @ok="batchDel">
        <jw-button size="mini" type="primary" status="danger">{{ $t('删除选中') }}</jw-button>

        <template #content>
          <p style="padding-bottom: 5px; font-weight: 600">
            {{ $t('你确定要删除所选记录吗？') }}
          </p>
          <p>
            {{ `${$t('你当前选中')} ${data.selectIds.length} ${$t('条记录，记录中的数据删除后将无法恢复！')}` }}
          </p>
        </template>
      </jw-popconfirm>
      <jw-button size="mini" v-else>{{ $t('删除选中') }}</jw-button>
    </div>
  </template>
  <template v-if="data.visible">
    <fh-table :max-height="500" from-page="35" header-affixed-top :pagination="null" :loading="data.tableloading" bordered :data="detailDataList?.length ? detailDataList : [{}]" :columns="data.columns" :class="['sub-form-table', props.isfull == 1 ? `sub-form-table-2 sub-form-table2${modulesItem.id}` : `sub-form-table${modulesItem.id}`]">
      <template v-for="(c, index) in data.columns?.filter((gc) => gc?.title != 'operation')" :key="index" #[c?.title]>
        <div class="custom-table-th">
          <div class="hint" v-if="c?.isRequired">*</div>
          {{ c?.fieldName }}
          <jw-tooltip v-if="c?.toast">
            <icon-question-circle size="18" class="custom-table-th-toast" />
            <!-- 这是提示文本  -->
            <template #content> {{ c.toast }} </template>
          </jw-tooltip>
        </div>
      </template>
      <template #operation>
        <div>{{ $t('序号') }}</div>
        <div :class="['sub-form-op-content', props.isfull == 1 ? 'set-opacity' : '']">
          <!-- 打开全屏状态 -->
          <icon-expand v-if="props.isfull == 0" size="16" class="cursor" style="margin-right: 10px" @click="fullScreen" />
          <!-- 收起全屏状态 -->
          <icon-shrink v-else size="16" class="cursor" style="margin-right: 10px" @click="fullScreen" />

          <jw-popover :title="$t('批量删除')" v-if="isCanEdit && (from == 30 || type == 30 || (type == 40 && modulesItem?.permission?.canEdit == 1 && modulesItem?.permission?.detail?.remove == 1))">
            <icon-delete size="16" @click="deleteAll" />
          </jw-popover>
        </div>
        <!-- 全选 -->
        <div v-if="data.checkedAllShow" class="checkedAll-content">
          <span>
            <jw-checkbox v-model="data.checkedAll" :indeterminate="data.indeterminate" @change="handleChangeAll"> </jw-checkbox>
          </span>
        </div>
      </template>
      <template #operationCell="{ row, rowIndex }">
        <!-- 真实有数据展示，空状态下伪数据不显示 -->
        <template v-if="detailDataList?.length">
          <div class="cell-index">
            {{ rowIndex + 1 }}
          </div>
          <div v-if="isCanEdit" class="sub-form-op-content">
            <icon-expand size="16" style="margin-right: 10px" @click="operationCk(1, rowIndex)" />
            <!-- （从基础信息里的子表才会有此判断） -->
            <!-- 30：新增默认都可删除 -->
            <!-- 40：编辑的时候，只有历史数据且有删除权限 -->
            <template v-if="from == 30 || type == 30 || (type == 40 && detailDataList[rowIndex][0]?.detailId && modulesItem?.permission?.canEdit == 1 && modulesItem?.permission?.detail?.remove == 1) || detailDataList[rowIndex][0]?.remove">
              <jw-popconfirm type="error" @ok="del(rowIndex)" :popup-container="props.isfull == 1 ? `.sub-form-table2${modulesItem.id}` : props.isfull == 0 && from == 30 ? '.add-table-modal' : `.sub-form-table${modulesItem.id}`">
                <icon-delete size="16" style="margin-right: 10px" />
                <template #content>
                  <p>{{ $t('该条记录存在数据，数据删除后将无法恢复，') }}</p>
                  <p>{{ $t('确定删除?') }}</p>
                </template>
              </jw-popconfirm>
            </template>
            <!-- 有可插入权限且新增权限 -->
            <template v-if="from == 30 || type == 30 || (type == 40 && modulesItem?.permission?.canEdit == 1 && modulesItem?.permission?.detail?.insert == 1 && modulesItem?.permission?.detail?.add == 1)">
              <jw-popover trigger="click" :popup-container="props.isfull == 1 ? `.sub-form-table2${modulesItem.id}` : props.isfull == 0 && from == 30 ? '.add-table-modal' : `.sub-form-table${modulesItem.id}`">
                <icon-more-vertical size="16" />
                <template #content>
                  <p>
                    <jw-button class="margin-b-10" @click="batchOp(1, row, rowIndex)">{{ $t('复制到下一行') }}</jw-button>
                  </p>
                  <p>
                    <jw-button class="margin-b-10" @click="batchOp(2, row, rowIndex)">{{ $t('复制到最后一行') }}</jw-button>
                  </p>
                  <p>
                    <jw-button class="margin-b-10" @click="batchOp(3, row, rowIndex)" :loading="data.loading">{{ $t('向上插入行') }}</jw-button>
                  </p>
                  <p>
                    <jw-button class="margin-b-10" @click="batchOp(4, row, rowIndex)" :loading="data.loading">{{ $t('向下插入行') }}</jw-button>
                  </p>
                </template>
              </jw-popover>
            </template>
            <!-- 没有可插入权限只有新增权限 -->
            <template v-if="from == 20 && type == 40 && modulesItem?.permission?.canEdit == 1 && !modulesItem?.permission?.detail?.insert && modulesItem?.permission?.detail?.add == 1">
              <jw-popover :title="$t('复制到最后一行')">
                <icon-copy size="16" @click="batchOp(2, row, rowIndex)" />
              </jw-popover>
            </template>
          </div>
          <!-- 选中 -->
          <div v-if="data.checkedAllShow" class="checkedAll-content">
            <!-- 不可删除的才禁用 -->
            <jw-checkbox-group :max="300" v-model="data.selectIds" :options="[rowIndex]" @change="handleChange">
              <template #label="{ data }">
                <span style="display: none">{{ data.value }}</span>
              </template>
            </jw-checkbox-group>
          </div>
        </template>
        <div v-else style="opacity: 0">-</div>
      </template>
      <template v-for="(c, index) in data.columns?.filter((gc) => gc?.title != 'operation')" #[c?.colKey]="{ rowIndex }" :key="c?.colKey">
        <!-- 真实有数据展示，空状态下伪数据不显示 -->
        <template v-if="detailDataList?.length">
          <xl-update-fields :modules="detailDataList[rowIndex]?.find((dl) => dl?.setting?.fieldKey == c?.colKey)" :formatData="detailDataList[rowIndex]" :from="35" :opType="1" :type="type" :rowIndex="rowIndex" @cb="updateModulesItem" :mainForm="mainForm" :popup-container="props.isfull == 0 ? `.sub-form-table${modulesItem.id}` : props.isfull == 1 ? `.sub-form-table2${modulesItem.id}` : ''" />
          <span class="arco-form-item-message" v-if="detailDataList[rowIndex][index].setting?.fieldType == 11 && detailDataList[rowIndex][index]?.fieldValue && !tools.checkLink(detailDataList[rowIndex][index].fieldValue)"> 格式不正确,请以http:// 或 https:// 开头,且不能包含汉字! </span>
        </template>
      </template>
    </fh-table>
  </template>
  <!-- 关联对象表格新增/编辑抽屉 -->

  <jw-drawer unmountOnClose :width="500" hide-cancel :visible="drawerVisible" class="sub-form-table-modal" @cancel="operationCk(0)" :closable="false">
    <template #title>
      <div class="drawer-title">
        <span>子表单</span>
        <div class="op-div-content">
          <div class="op-number-content">
            <span class="switch-icon" @click="switchForm(1)"><icon-caret-left /></span>

            <span class="op-number-icon-content">
              <span> {{ data.recordIndex + 1 }}</span
              >/ <span> {{ detailDataList?.length }}</span></span
            >
            <span class="switch-icon" @click="switchForm(2)"><icon-caret-right /></span>
          </div>

          <span class="switch-icon" @click="operationCk(0)"><icon-shrink class="cursor" /></span>
        </div>
      </div>
    </template>
    <jw-form :model="data.form" label-align="left" class="sub-form-drawer" ref="formRef" @submit="handleSubmit">
      <jw-row :gutter="24">
        <template v-for="(item, index) in data.form.subForm" :key="item.id">
          <jw-col :span="24">
            <jw-form-item asterisk-position="end" :field="`subForm.${index}.fieldValue`" :class="['system-form-item', item?.setting?.fieldType === 12 ? 'relevancy-input' : '']" :rules="rules(item)" :validate-trigger="['blur', 'input', 'change']" :label-col-style="{ width: '120px' }" label-col-flex="auto" class="form-label-text">
              <template #label>
                <xl-label-text :value="item.setting?.fieldName" :row="1" />
                <jw-tooltip v-if="item?.toast">
                  <icon-question-circle size="18" />
                  <!-- 这是提示文本  -->
                  <template #content> {{ item.toast }} </template>
                </jw-tooltip>
              </template>
              <template v-if="updateSubForm">
                <xl-update-fields :modules="item" :formatData="data.form.subForm" :from="35" :type="type" @cb="updateDrawerModulesItem" :mainForm="mainForm" popup-container=".sub-form-drawer" />
              </template>
            </jw-form-item>
            <!--附加说明 -->
            <div class="tips-detail" v-if="item?.memo">{{ item?.memo }}</div>
          </jw-col>
        </template>
      </jw-row>
    </jw-form>
    <template #footer>
      <jw-button type="primary" size="small" v-if="from == 30 || (from == 20 && type == 30) || (type == 40 && modulesItem?.permission?.canEdit == 1 && modulesItem?.permission?.detail?.add == 1)" @click="formRef.handleSubmit(1)">{{ $t('复制') }}</jw-button>
      <jw-button type="primary" size="small" v-if="from == 30 || (from == 20 && type == 30) || (type == 40 && modulesItem?.permission?.canEdit == 1 && modulesItem?.permission?.detail?.add == 1)" @click="formRef.handleSubmit(2)" :loading="data.loading">
        {{ $t('确定并添加一条') }}
      </jw-button>
      <jw-button type="primary" size="small" @click="formRef.handleSubmit()">{{ $t('确定') }}</jw-button>
    </template>
  </jw-drawer>
</template>
<script setup>
import { reactive, ref, inject, nextTick, watchEffect, watch } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import useViewFields from '@/hooks/view-fields';
const { rules } = useViewFields();
const formRef = ref(); //表单
import { tools } from '@/utils/tools';
import _ from 'lodash';
import { publicService } from '@/api/';
// const subHeaderRef=ref();//表格操作容器
// import dayjs from 'dayjs';
const { setCallbackData } = inject('methods'); //父组件方法--同步数据给父组件
import { Message } from '@arco-design/web-vue';
import fieldDefaultVal from '@/hooks/default-value'; //默认值相关的hooks
const { getNewDefVal } = fieldDefaultVal();

const props = defineProps({
  modulesItem: {
    //规则过滤后的表格的字段信息
    type: Object,
    default: () => {}
  },
  allModules: {
    //全部表格的字段信息
    type: Object,
    default: () => {}
  },
  dataList: {
    //表格列表
    type: Array,
    default: () => []
  },
  isfull: {
    //0：非全屏状态，1：全屏状态
    type: Number || String,
    default: 0
  },
  from: {
    //来源
    // 20 是基本信息  30 是关联表格
    type: Number || String,
    default: () => 20
  },
  //30:新增 40：编辑
  type: {
    type: Number || String,
    default: 30
  },
  entity: {
    type: Number || String,
    default: null
  },
  mainForm: {
    //主表数据
    type: Array,
    default: () => []
  },
  isCanEdit: {
    //规则是否可编辑
    type: Boolean,
    default: true
  }
});
const drawerVisible = ref(false); //新增、编辑抽屉
const emits = defineEmits(['cb']);
const data = reactive({
  tableloading: false,
  loading: false,
  checkedAllShow: false, //是否显示全选
  checkedAll: false, //批量删除
  indeterminate: false, //半选状态
  selectIds: [], //选中的数据
  form: {
    subForm: props.modulesItem.modules
  },
  recordIndex: '',
  visible: true,
  recordIndexCb: '',
  recordIndexItem: {},
  columns: []
});
const detailDataList = ref(props.dataList); //列表数据
watch(
  () => props.modulesItem.modules,
  () => {
    data.form.subForm = props.modulesItem.modules;
    const _fieldData = {}; //字段的是否必填 是否可编辑集合
    props.modulesItem.modules?.forEach((mim) => {
      _fieldData[mim?.value] = {
        isRequired: mim?.isRequired,
        businessData: mim?.businessData,
        display: mim?.display
      };
    });
    //遍历处理数据 将页面已有数据做必填和不可编辑判断
    // const a = _.cloneDeep(detailDataList.value)
    detailDataList.value.map((ddl) => {
      if (ddl?.length) {
        ddl?.map((ddlm) => {
          if (_fieldData?.[ddlm?.value]) {
            const _isRequired = _fieldData?.[ddlm?.value]?.isRequired;
            ddlm.businessData = _fieldData?.[ddlm?.value]?.businessData;
            ddlm.isRequired = _isRequired;
            ddlm.setting.isRequired = _isRequired;
            ddlm.display = _fieldData?.[ddlm?.value]?.display;
          }
        });
      }
    });
    nextTick(() => {
      updataSubForm();
      data.columns = getColumns();
    });
  },
  { deep: true, immediate: true }
);

watchEffect(() => {
  detailDataList.value = props.dataList;
});
const updataSubForm = () => {
  setCallbackData({
    id: props.modulesItem.id,
    modules: _.cloneDeep(detailDataList.value)
  });
};
// 子表表格获取字段
const getColumns = () => {
  const list = [
    {
      title: 'operation',
      colKey: 'operationCell',
      fixed: 'left',
      cell: 'operationCell',
      width: 80
    }
  ];
  props?.modulesItem?.modules?.forEach((item) => {
    const colType = {
      title: 'title-' + item?.setting?.fieldKey, //定制title插槽名称
      colKey: item?.setting?.fieldKey,
      conditionsIsRequired: item?.conditionsIsRequired,
      width: item?.setting?.fieldName.length <= 5 ? 180 : item?.setting?.fieldName.length * 30,
      fieldName: item?.setting?.fieldName,
      isRequired: item?.setting?.isRequired,
      toast: item?.toast
    };

    list.push({ ...colType });
  });
  return list;
};
// 解决表头滚动，body内容错乱问题
const dispatchScroll = () => {
  if (!detailDataList.value || detailDataList.value?.length == 0) {
    const subFormTables = props.isfull == 1 ? document.querySelectorAll(`.sub-form-table2${props?.modulesItem.id}`) : document.querySelectorAll(`.sub-form-table${props?.modulesItem.id}`);
    const arcoTableBody = subFormTables?.[0]?.querySelector('.arco-table-body');
    if (arcoTableBody) {
      arcoTableBody.scrollLeft = 1;
      const scrollEvent = new Event('scroll', {
        bubbles: true,
        cancelable: true
      });
      // 触发 scroll 事件
      arcoTableBody.dispatchEvent(scrollEvent);
    }
  }
};
// 是表格的body滚动到新添加的数据位置
const setTbodyScrollTo = (rowIndex) => {
  if (detailDataList.value && detailDataList.value.length > 0) {
    const subFormTables = props.isfull == 1 ? document.querySelectorAll(`.sub-form-table2${props?.modulesItem.id}`) : document.querySelectorAll(`.sub-form-table${props?.modulesItem.id}`);

    // 确保至少有一个匹配的元素
    if (subFormTables.length > 0) {
      const arcoTableBody = subFormTables[0].querySelector('.arco-table-body');

      if (arcoTableBody) {
        // 获取第一个行元素的高度
        const getArcoTableTr = arcoTableBody.querySelector('.arco-table-tr');

        if (getArcoTableTr) {
          const getArcoTableTrHeight = getArcoTableTr.offsetHeight;

          // 计算滚动位置
          const scrollToPosition = getArcoTableTrHeight * rowIndex;
          //   console.log("arcoTableBody----",scrollToPosition,rowIndex)
          // 设置滚动条位置
          arcoTableBody.scrollTop = scrollToPosition;
        }
      }
    }
  }
};
// 更新子表字段默认值
const updateSubFieldModule = async (modules) => {
  if (props.from == 20 && props.type == 30) {
    //主表来源,新建，复制触发
    data.loading = true;
    const params = {
      entity: props.entity,
      formData: props.mainForm,
      subFormKey: props?.modulesItem?.setting?.fieldKey,
      modules: modules,
      init: false
    };
    await getNewDefVal(params, 2);
    data.loading = false;
  }
};
// 新增--子表单数据
const addDetail = async () => {
  if (detailDataList.value && detailDataList.value?.length >= 300) {
    Message.warning('子表单数据最多添加300行！');
    return;
  }
  dispatchScroll();
  //2025年05月28日16:12:45 allModule适用于业务规则补全，为空时是关联对象表格弹窗调用，此时不涉及业务规则，直接使用moduleItem
  const modules = _.cloneDeep(props?.allModules?.modules ?? props?.modulesItem?.modules);
  await updateSubFieldModule(modules);

  modules?.forEach((item) => {
    // item.businessData = '1';
    item['remove'] = 1; //可删除
  });
  detailDataList.value?.push(modules);
  updataSubForm();
  nextTick(() => {
    setTbodyScrollTo(detailDataList.value.length);
  });
};
//批量删除
const deleteAll = () => {
  data.checkedAllShow = !data.checkedAllShow;
  data.selectIds = [];
  data.indeterminate = false;
  data.checkedAll = false;
};
// 单条选中
const handleChange = (value, ev) => {
  console.log('rowKeys', value, ev, data.selectIds);
  data.indeterminate = false;
  data.checkedAll = false;
  if (data.selectIds?.length == detailDataList.value?.length) {
    //全选了
    data.checkedAll = true;
  } else {
    data.indeterminate = true;
    if (data.selectIds?.length == 0) {
      data.indeterminate = false;
    }
  }
};
//批量--全选
const handleChangeAll = (value) => {
  data.indeterminate = false;
  data.selectIds = [];
  if (value) {
    data.checkedAll = true;
    detailDataList.value?.forEach((item, index) => {
      data.selectIds.push(index);
    });
  } else {
    data.checkedAll = false;
  }
};
//更新表格视图
const updateTableView = () => {
  updataSubForm(); //更新数据
  // 触发视图更新
  data.visible = false;
  nextTick(() => {
    data.visible = true;
  });
};
const updateSubForm = ref(true); //刷新表单数据
//更新表单视图
const updateFormView = () => {
  // 触发视图更新
  updateSubForm.value = false;
  nextTick(() => {
    updateSubForm.value = true;
  });
};
//单条删除
const del = (rowIndex) => {
  detailDataList.value.splice(rowIndex, 1);
  updateTableView();
  setTimeout(() => {
    setTbodyScrollTo(rowIndex);
  }, 1);
};
//批量删除
const batchDel = () => {
  // 首先将索引排序，从大到小排列
  const sortedRowIndices = data.selectIds?.sort((a, b) => b - a);

  sortedRowIndices?.forEach((rowIndex) => {
    // 确保索引在有效范围内
    if (rowIndex >= 0 && rowIndex < detailDataList.value.length) {
      detailDataList.value.splice(rowIndex, 1);
    }
  });
  data.checkedAll = false;
  data.indeterminate = false;
  data.selectIds = [];
  data.checkedAllShow = false;
  updateTableView();
};
// 操作(type==0:取消或者关闭编辑抽屉，type==1:打开编辑抽屉)
const operationCk = async (type, rowIndex = {}) => {
  if (type == 1) {
    data.recordIndex = rowIndex;
    data.form.subForm = detailDataList.value[rowIndex];
  }

  drawerVisible.value = !drawerVisible.value;
};
//切换表单 type:1 左切 type:2 右切
const switchForm = (type) => {
  if (type == 1) {
    if (data.recordIndex < 1) {
      return;
    }
    data.recordIndex--;
  }
  if (type == 2) {
    if (data.recordIndex >= detailDataList.value?.length - 1) {
      return;
    }
    data.recordIndex++;
  }
  data.form.subForm = detailDataList.value[data.recordIndex];
  updateFormView();
};
// 批量操作 batchOp(1)复制到下一行,batchOp(2)复制到最后一行,batchOp(3)向上插入行,batchOp(4)向下插入行,
const batchOp = async (type, record, rowIndex) => {
  if (detailDataList.value && detailDataList.value?.length >= 300) {
    Message.warning('子表单数据最多添加300行！');
    return;
  }
  const modules = _.cloneDeep(props?.modulesItem?.modules); // 深拷贝原始数据
  const getRowIndexRecord = _.cloneDeep(record); // 深拷贝当前行的数据
  if ([3, 4].includes(type)) await updateSubFieldModule(modules);

  getRowIndexRecord?.map((r) => {
    r['detailId'] = ''; //唯一标识id
    r['businessData'] = '1'; //可编辑
    r['remove'] = 1; //可删除
  });
  modules?.map((r) => {
    r['detailId'] = ''; //唯一标识id
    r['businessData'] = '1'; //可编辑
    r['remove'] = 1; //可删除
  });
  // 根据类型处理不同的操作
  switch (type) {
    case 1: // 复制到下一行
      detailDataList.value.splice(rowIndex + 1, 0, getRowIndexRecord);
      break;
    case 2: // 复制到最后一行
      detailDataList.value.push(getRowIndexRecord);
      break;
    case 3: // 向上插入行
      // 如果是第一行，则插入到开头
      if (rowIndex === 0) {
        detailDataList.value.unshift(modules);
      } else {
        // 否则，插入到当前行的前面
        detailDataList.value.splice(rowIndex, 0, modules);
      }
      break;
    case 4: // 向下插入行
      detailDataList.value.splice(rowIndex + 1, 0, modules);
      break;
    default:
      console.error('Invalid operation type:', type);
  }
  updateTableView();
  setTimeout(() => {
    var newRowIndex = type == 1 || type == 4 ? rowIndex + 1 : type == 2 ? detailDataList.value.length : rowIndex;
    setTbodyScrollTo(newRowIndex);
  }, 1);
};
const setDetailDataFieldValue = (cfm, _tmpData) => {
  const key = cfm?.setting?.fieldKey;
  const fieldType = cfm?.setting?.fieldType;
  const fieldExt = cfm?.setting?.fieldExt;
  let fieldValue = _tmpData[key];
  if (fieldType == 2 || fieldType == 4) {
    //2.单选 4.下拉单选
    fieldValue = _tmpData[key] || _tmpData[key] === 0 || _tmpData[key] === '0' ? _tmpData[key] : '';
  } else if (fieldType == 3 || fieldType == 5) {
    //3.多选 5.下拉多选
    fieldValue = _tmpData[key] ? _tmpData[key].split(',') : [];
  } else if (fieldType == 6) {
    //6.人员
    const _user = [];
    const _name = [];
    const _list = _tmpData[key] ? (Array.isArray(_tmpData[key]) ? _tmpData[key] : [_tmpData[key]]) : [];
    _list.forEach((v) => {
      _user.push({
        id: v.userId || v.id || '',
        userName: v.userName,
        avatarOrigin: v.avatar || v.avatarOrigin || ''
      });
      _name.push(v.userName);
    });
    cfm.setting['fv'] = {
      userList: _user,
      departList: []
    };
    fieldValue = _name;
  } else if (fieldType == 7) {
    //7.数字
    fieldValue = _tmpData[key] ? parseFloat(_tmpData[key]) : '';
  } else if (fieldType == 8) {
    //8.日期
    fieldValue = _tmpData[key];
  } else if (fieldType == 9) {
    //9.日期范围
    if (tools.isJSON(_tmpData[key]) && JSON.parse(_tmpData[key])?.beginDate && JSON.parse(_tmpData[key])?.endDate) {
      fieldValue = [JSON.parse(_tmpData[key])?.beginDate, JSON.parse(_tmpData[key])?.endDate];
    } else {
      fieldValue = null;
    }
  } else if (fieldType == 10) {
    //10.级联选择器
    fieldValue = _tmpData[key] ? _tmpData[key].split('/') : [];
  } else if (fieldType == 16) {
    //16.金额
    fieldValue = tools.getPrice(_tmpData[key], fieldExt ? fieldExt : 2);
  } else if (fieldType == 18) {
    //18.附件
    fieldValue = _tmpData[key] && tools.isJSON(_tmpData[key]) ? JSON.parse(_tmpData[key]) : [];
  } else if (fieldType == 22) {
    //22.部门
    const _depart = [];
    const _name = [];
    const _list = _tmpData[key] ? (Array.isArray(_tmpData[key]) ? _tmpData[key] : [_tmpData[key]]) : [];
    _list.forEach((v) => {
      _depart.push({
        id: v.departmentId || v.id || '',
        departmentName: v.departmentName || v.name || ''
      });
      _name.push(v.departmentName || v.name || '');
    });
    cfm.setting['fv'] = {
      departList: _depart,
      userList: []
    };
    fieldValue = _name;
  } else if (fieldType == 23) {
    //23.百分比
    fieldValue = tools.getPercentage(_tmpData[key], JSON.parse(fieldExt)?.numberFormat || 2);
  }
  return fieldValue;
};
const checkFieldMatch = (modulesItem, fieldValue) => {
  // 遍历detailDataList中的每个元素（每个元素都是一个数组）
  const getDataList = detailDataList.value;
  for (var i = 0; i < getDataList.length; i++) {
    var item = getDataList[i];

    // 检查当前数组内的每个对象
    for (var j = 0; j < item.length; j++) {
      if (item[j]?.setting?.fieldKey === modulesItem?.setting?.fieldKey) {
        // 如果找到匹配项，则返回true
        if (item[j]?.fieldValue && item[j]?.fieldValue?.length > 0 && item[j]?.fieldValue.includes(fieldValue)) {
          return true;
        }
      }
    }
  }

  // 如果没有找到任何匹配项，则返回false
  return false;
};

// 多选给表格添加数据
const updateDetailDataList = (rowIndex, modulesItem, _tmpData) => {
  const getValList = _.cloneDeep(modulesItem.customValue);
  if (modulesItem?.fieldValue && modulesItem?.fieldValue?.length) {
    modulesItem?.fieldValue?.forEach((item, index) => {
      if (index == 0) {
        detailDataList.value[rowIndex]?.forEach((el) => {
          if (el?.setting?.fieldKey == modulesItem?.setting?.fieldKey) {
            el.fieldValue = [item];
            el.customValue = [modulesItem.customValue?.[index]];
          } else {
            if (_tmpData?.[item] && Object?.keys(_tmpData?.[item]).includes(el?.setting?.fieldKey)) {
              el.fieldValue = setDetailDataFieldValue(el, _tmpData?.[item]);
            }
          }
        });
      } else {
        if (!checkFieldMatch(modulesItem, item)) {
          //表格数据中不存在就向表格添加
          const module = _.cloneDeep(props?.modulesItem?.modules);
          module?.forEach((el) => {
            el['detailId'] = ''; //唯一标识id
            el['businessData'] = '1'; //可编辑
            el['remove'] = 1; //可删除

            if (el?.setting?.fieldKey == modulesItem?.setting?.fieldKey) {
              el.fieldValue = [item];
              el.customValue = getValList?.filter((v) => v.id == item);
            } else {
              if (_tmpData?.[item] && Object?.keys(_tmpData?.[item]).includes(el?.setting?.fieldKey)) {
                el.fieldValue = setDetailDataFieldValue(el, _tmpData?.[item]);
              }
            }
          });
          detailDataList.value.push(module);
        }
      }
    });
  }
};
// 查找关联单选/多选赋值
const getAssociationAssign = async (modulesItem, rowIndex, eventType) => {
  const params = {
    eventType: eventType, //0:新增 1：修改 2：清除
    layoutConfigId: modulesItem?.id, //当前字段的id
    fieldKey: modulesItem?.setting?.fieldKey,
    entity: modulesItem?.setting?.entityId,
    associateEntity: modulesItem?.setting?.fieldExt,
    settingId: modulesItem?.setting?.id
  };
  if (modulesItem?.setting?.fieldType == 25) params.associateIdList = modulesItem?.fieldValue; //多选
  if (modulesItem?.setting?.fieldType == 12) params.associateId = modulesItem?.fieldValue; //单选
  const res = await publicService.getAssociationAssign(params);
  if (!res.error) {
    if (res.result && Object?.keys(res.result).length > 0) {
      const _tmpData = res.result;
      if (modulesItem?.setting?.fieldType == 12) {
        detailDataList.value[rowIndex].map((cfm) => {
          if (Object?.keys(_tmpData)?.includes(cfm?.setting?.fieldKey)) {
            cfm.fieldValue = setDetailDataFieldValue(cfm, _tmpData);
          }
        });
      }
      if (modulesItem?.setting?.fieldType == 25) {
        updateDetailDataList(rowIndex, modulesItem, _tmpData);
      }
      updataSubForm();
    }
  }
};
// 查找关联单选、多选赋值逻辑
const setAssociationAssign = async () => {
  if (data.recordIndexItem?.setting?.fieldType == 12 || data.recordIndexItem?.setting?.fieldType == 25) {
    if (data.recordIndexItem?.fieldAssignment && data.recordIndexItem?.fieldAssignment?.entityFieldRuleEvent && data.recordIndexItem?.fieldAssignment?.fieldAssignmentRules?.length > 0) {
      //查找关联有映射规则
      if ((data.recordIndexItem?.setting?.fieldType == 12 && data.recordIndexItem?.fieldValue) || (data.recordIndexItem?.setting?.fieldType == 25 && data.recordIndexItem?.fieldValue?.length > 0)) {
        await getAssociationAssign(data.recordIndexItem, data.recordIndexCb, 0);
      }
    }
  }
};

// 抽屉里字段回调
const updateDrawerModulesItem = async (getformatData, modulesItem) => {
  if (getformatData) {
    data.form.subForm = getformatData;
  }
  if ([6, 22, 18].includes(parseInt(modulesItem?.setting?.fieldType))) {
    //人员或部门
    data.form.subForm?.forEach((item, index) => {
      if (item.type == 20) {
        if (item?.setting?.fieldKey == modulesItem.value) {
          formRef.value?.clearValidate([`subForm.${index}.fieldValue`]);
        }
      }
    });
  }

  data.recordIndexCb = data.recordIndex; //当前行的索引
  data.recordIndexItem = modulesItem; //当前行的字段
  updataSubForm();
  setAssociationAssign();
};
// 表格里编辑---字段子组件回调
const updateModulesItem = async (getformatData, modulesItem, rowIndex) => {
  if (getformatData) {
    detailDataList.value[rowIndex] = getformatData;
  }

  data.recordIndexCb = rowIndex; //当前行的索引
  data.recordIndexItem = modulesItem; //当前行的字段
  updataSubForm();
  setAssociationAssign();
};
// 全屏
const fullScreen = () => {
  emits('cb');
};
// 表单提交 （操作(type==1:复制，type==2:确定并添加一条，type==3:确定并)）
const handleSubmit = async ({ values, errors }, type) => {
  if (!errors) {
    //文件未上传完给提示
    const incompleteFileList = [];
    data.form.subForm?.forEach((item) => {
      if (item.type == 20 && item?.setting?.fieldType === 18) {
        if (item.fieldValue && item.filesList && item.fieldValue.length != item.filesList.length) {
          incompleteFileList.push(item.fieldValue);
        }
      }
    });

    if (incompleteFileList && incompleteFileList.length) {
      Message.warning(t('文件未上传完成,请稍后提交！'));
      return;
    }
    console.log(values);
    //   data.form.subForm?.map((v) => {
    //     if (v?.setting?.fieldType === 6 || v?.setting?.fieldType === 22) {
    //       v.setting['fv'] = [];
    //     }
    //     if (v?.setting?.fieldType === 18) {
    //       v.filesList = [];
    //       v.fieldValue = [];
    //     }
    //   });
    if (type == 1 || type == 2) {
      //1：复制  /:2：确定并添加一条
      if (detailDataList.value && detailDataList.value?.length >= 300) {
        Message.warning('子表单数据最多添加300行！');
        return;
      }
      const getRowIndexRecord = type == 1 ? _.cloneDeep(detailDataList.value[data.recordIndex]) : _.cloneDeep(props?.modulesItem?.modules); // 深拷贝当前行的数据

      if (type == 2) await updateSubFieldModule(getRowIndexRecord);

      getRowIndexRecord.map((r) => {
        r['detailId'] = ''; //唯一标识id
        r['businessData'] = '1';
        r['remove'] = 1; //可删除
      });
      detailDataList.value.push(getRowIndexRecord);
      updataSubForm();
      data.recordIndex = detailDataList.value?.length - 1;
      if (type == 1) {
        data.form.subForm = detailDataList.value[data.recordIndex];
      } else {
        data.form.subForm = getRowIndexRecord;
      }
      updateFormView();
      nextTick(() => {
        setTbodyScrollTo(detailDataList.value.length);
      });
    } else {
      // 确定--关闭
      drawerVisible.value = false;
    }
  }
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
<style lang="less">
.sub-form-table-modal {
  .arco-drawer-header {
    .arco-drawer-title {
      width: 100%;

      .drawer-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .op-div-content {
          display: flex;
          align-items: center;
          cursor: pointer;

          .op-number-content {
            display: flex;
            align-items: center;
            margin-right: 10px;

            .op-number-icon-content {
              span {
                font-size: 14px;
              }
            }
          }

          .switch-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            border-radius: 5px;
            cursor: pointer;
          }

          .switch-icon:hover {
            background-color: var(--color-fill-2);
          }
        }
      }
    }
  }

  .arco-modal-body {
    min-height: 300px;
    // max-height: 750px;
  }

  .system-form-item-fields {
    width: 296px;
  }

  .arco-drawer-footer {
    .arco-icon-loading {
      font-size: 10px;
    }
  }
}
</style>
